let dirPath = 'static/games/page006_game3';
let dirAudio = 'games/page006_game3/audio/';

let configGame = {
  removeInCorrects: true,
  correctBlock: true,
  //autoCheckAllCorrect: true,
  rulesGame: {
    itemsConfig: {
      block: true,
      shuffle: true,
    },
    otherProperty: {
      sounds: [{ src: dirPath + '/audio/klik.mp3', id: 'mouseup' }],
    },
    items: [
      {
        idGroup: 'target',
        idItem: 't01',
        items: [
          {
            idGroup: 'source',
            idItem: 's01',
            correct: [{ idGroup: 'target', idItem: 't01' }],
          },
        ],
      },
      {
        idGroup: 'target',
        idItem: 't02',
        items: [
          {
            idGroup: 'source',
            idItem: 's02',
            correct: [{ idGroup: 'target', idItem: 't02' }],
          },
        ],
      },
      {
        idGroup: 'target',
        idItem: 't03',
        items: [
          {
            idGroup: 'source',
            idItem: 's03',
            correct: [{ idGroup: 'target', idItem: 't03' }],
          },
        ],
      },
      {
        idGroup: 'target',
        idItem: 't04',
        items: [
          {
            idGroup: 'source',
            idItem: 's04',
            correct: [{ idGroup: 'target', idItem: 't04' }],
          },
        ],
      },
      {
        idGroup: 'target',
        idItem: 't05',
        items: [
          {
            idGroup: 'source',
            idItem: 's05',
            correct: [{ idGroup: 'target', idItem: 't05' }],
          },
        ],
      },
    ],
  },
  layout: {
    itemsConfig: {
      positions: {
        margin: { left: 5, bottom: 5 },
      },
      background: {
        color: 'transparent',
        text: { size: '30px', textAlign: 'left', textBaseline: 'top', font: 'Myriad Pro' },
      },
    },
    groups: [
      {
        idGroup: 'target',
        itemsConfig: {
          positions: { pos: { width: 519, height: 403 } },
        },
        positions: {
          type: 'absolute',
          fixTab: [
            { x: 100, y: 0 },
            { x: 700, y: 0 },
            { x: 1300, y: 0 },
            { x: 100, y: 420 },
            { x: 700, y: 420 },
          ],
        },
        otherProperty: {
          hooks: {
            background: { color: 'rgba(255,255,255,0.01)' },
            items: [{ id: 'h01', positions: { pos: { x: 10, y: 160, width: 490, height: 216 } } }],
          },
        },
        items: [
          {
            id: 't01',
            background: {
              image: { src: dirPath + '/img/10.png' },
            },
            otherProperty: { audio: 'a01' },
          },
          {
            id: 't02',
            background: {
              image: { src: dirPath + '/img/11.png' },
            },
            otherProperty: { audio: 'a02' },
          },
          {
            id: 't03',
            background: {
              image: { src: dirPath + '/img/12.png' },
            },
            otherProperty: { audio: 'a03' },
          },
          {
            id: 't04',
            background: {
              image: { src: dirPath + '/img/13.png' },
            },
            otherProperty: { audio: 'a04' },
          },
          {
            id: 't05',
            background: {
              image: { src: dirPath + '/img/14.png' },
            },
            otherProperty: { audio: 'a05' },
          },
        ],
      },
      {
        idGroup: 'source',
        background: {
          color: 'transparent',
        },
        positions: {
          type: 'absolute',
          pos: { x: 1250, y: 400 },
          autoFit: true,
        },
        itemsConfig: {
          positions: {
            type: 'absolute',
          },
        },
        items: [
          {
            id: 's01',
            positions: { pos: { x: 50 + 80, y: 100, height: 195, width: 135 } },
            background: {
              image: { src: dirPath + '/img/00.png' },
            },
          },
          {
            id: 's02',
            positions: { pos: { x: 250 + 80, y: 100, height: 190, width: 188 } },
            background: {
              image: { src: dirPath + '/img/03.png' },
            },
          },
          {
            id: 's03',
            positions: { pos: { x: 50 + 80, y: 300, height: 132, width: 132 } },
            background: {
              image: { src: dirPath + '/img/01.png' },
            },
          },
          {
            id: 's04',
            positions: { pos: { x: 0 + 80, y: 0, height: 89, width: 456 } },
            background: {
              image: { src: dirPath + '/img/02.png' },
            },
          },
          {
            id: 's05',
            positions: { pos: { x: 300 + 80, y: 300, height: 132, width: 132 } },
            background: {
              image: { src: dirPath + '/img/04.png' },
            },
          },
        ],
      },
    ],
  },
};

let dataConfig = {
  mixinEngine: 'dnd',
  realHeight: 850,
  mainImage: {
    imagePath: dirPath + '/img/bgr.png',
    pos: {
      y: 0,
      x: 0,
    },
  },
  mbAudioItemData: [
    {
      id: 'a01',
      src: dirAudio + 'z6c2-1.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        fill: 'black',
      },
      pos: {
        y: 202,
        x: 70,
      },
      width: '57px',
      height: '57px',
      unit: 'px',
    },
    {
      id: 'a02',
      src: dirAudio + 'z6c2-2.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        fill: 'black',
      },
      pos: {
        y: 202,
        x: 70,
      },
      width: '57px',
      height: '57px',
      unit: 'px',
    },
    {
      id: 'a03',
      src: dirAudio + 'z6c2-4.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        fill: 'black',
      },
      pos: {
        y: 202,
        x: 70,
      },
      width: '57px',
      height: '57px',
      unit: 'px',
    },
    {
      id: 'a04',
      src: dirAudio + 'z6c2-5.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        fill: 'black',
      },
      pos: {
        y: 202,
        x: 70,
      },
      width: '57px',
      height: '57px',
      unit: 'px',
    },
    {
      id: 'a05',
      src: dirAudio + 'z6c2-3.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        fill: 'black',
      },
      pos: {
        y: 202,
        x: 70,
      },
      width: '57px',
      height: '57px',
      unit: 'px',
    },
  ],
  cssStyle: {
    overflow: 'hidden',
  },
  configGame: configGame,
};

export default dataConfig;
